const responseDataReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_RESPONSE_DATA':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default responseDataReducer